import { Link } from "react-router-dom";
import { site } from "@/data/site";
import { LogoMark } from "@/components/LogoMark";

export const Logo = ({ invert = false }: { invert?: boolean }) => (
  <Link to="/" data-testid="logo-home-link" className="group flex items-center gap-3">
    <span className={`shrink-0 ${invert ? "text-paper" : "text-ink"}`}>
      <LogoMark className="h-12 w-auto transition-transform duration-500 group-hover:rotate-[-4deg]" />
    </span>
    <span className="leading-tight">
      <span className={`block font-serif text-lg font-bold tracking-tight ${invert ? "text-paper" : "text-ink"}`}>
        {site.short}
      </span>
      <span className={`block text-[10px] font-medium uppercase tracking-[0.16em] ${invert ? "text-paper/60" : "text-mutedtx"}`}>
        Don Lorenzo Milani · Genova
      </span>
    </span>
  </Link>
);
